'use client';
import { useTranslations } from 'next-intl';
import { useParams } from 'next/navigation';
import { getSeoUrl } from 'utils/links';
import { CatIconShieldCheck } from '@blocks-react/components/Icons/ShieldCheck';
import { CatIconShippingFast } from '@blocks-react/components/Icons/ShippingFast';
import { CatIconCreditCard } from '@blocks-react/components/Icons/CreditCard';
import { CatValueCard, useBreakpoint } from 'components/pcc-components';
import { PAGE_BREAKPOINTS } from 'constants/common';

export const CatValueWrapper = () => {
  const t = useTranslations();
  const isLG = useBreakpoint(PAGE_BREAKPOINTS.LG);
  const params = useParams();
  const esiteUrl = getSeoUrl(params);
  const iconSize = isLG ? 'xl' : 'lg';
  const iconColor = 'knockout-brand';

  const catValues = [
    {
      className: 'footer_design',
      title: 'HP_CAT_VALUE_TITLE1',
      content: 'HP_CAT_VALUE_BODY1',
      icon: <CatIconShieldCheck color={iconColor} size={iconSize} />,
      redirectUrl: `${esiteUrl}/about`,
      target: '_self',
      nltext: 'Built to Last'
    },
    {
      className: 'footer_design',
      title: 'HP_CAT_VALUE_TITLE2',
      content: 'HP_CAT_VALUE_BODY2',
      icon: <CatIconShippingFast color={iconColor} size={iconSize} />,
      redirectUrl: `${esiteUrl}/pickup-delivery`,
      target: '_self',
      nltext: 'Quick Delivery'
    },
    {
      className: 'footer_design',
      title: 'HP_CAT_VALUE_TITLE3',
      content: 'HP_CAT_VALUE_BODY3',
      icon: <CatIconCreditCard color={iconColor} size={iconSize} />,
      redirectUrl: `${esiteUrl}/payment-options`,
      target: '_self',
      nltext: 'Pay Your Way'
    }
  ];

  return (
    <div
      className="d-flex flex-column flex-md-row gap-3 mt-lg-3"
      data-testid="cat-value-wrapper"
    >
      {catValues.map((card) => {
        return (
          <CatValueCard
            className={card.className}
            key={card.title}
            title={t(card.title)}
            icon={card.icon}
            content={t(card.content)}
            redirectUrl={card.redirectUrl}
            target={card.target}
            nltext={card.nltext}
          />
        );
      })}
    </div>
  );
};
